import './index.scss'

export default function NetworkingDetails(props) {
    const {details} = props;
    return <>
        <div className="NetworkingDetails">Деталі: {details.details}</div>
    </>
}
